<script>
import YesNo from '@wielink-application/shared/vue/components/form/horizontal/yesno.vue';

export default YesNo;
</script>